import React, { useState, useEffect, useRef } from 'react';
import { Plus, Upload, Search, Filter, List, Grid } from 'lucide-react';
import AddOperatingInstruction from './addOperatingInstructionModal';
import { getOperationInstruction } from '../../../services/operationInstructionServices';
import Cookies from 'js-cookie';

interface OperatingInstructionHeaderProps {
  onOpenUploadModal: () => void;
  onOpenAddInstruction: () => void;
  onSearch?: (value: string) => void;
}

const OperatingInstructionHeader: React.FC<OperatingInstructionHeaderProps> = ({ onOpenUploadModal, onOpenAddInstruction, onSearch }) => {
  const [searchQuery, setSearchQuery] = useState(''); //  ADDED
  const debounceRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  const role = Cookies.get('role');

  useEffect(() => {
    if (debounceRef.current) clearTimeout(debounceRef.current);

    debounceRef.current = setTimeout(() => {
      onSearch?.(searchQuery);
    }, 500);

    return () => {
      if (debounceRef.current) clearTimeout(debounceRef.current);
    };
  }, [searchQuery]);

  return (
    <div className="flex items-center gap-4 p-4">
      {/* Left Section */}
      {role === 'shift_supervisor' && (
        <div className="flex items-center gap-3">
          {/* Add Operating Instruction */}
          <button
            className="flex items-center gap-2 bg-red-600 hover:bg-red-700 text-white px-4 py-2 rounded-lg shadow-sm -ml-4"
            onClick={onOpenAddInstruction}
          >
            <Plus size={16} /> Operating Instruction
          </button>

          {/* Upload Document */}
          {/* <button
            onClick={onOpenUploadModal}
            className="flex items-center gap-2 border border-gray-300 text-gray-700 px-4 py-2 rounded-lg hover:bg-gray-50"
          >
            <Upload size={16} /> Upload Document
          </button> */}
        </div>
      )}
      {/* Right Section */}
      <div className="flex items-center gap-3 ml-auto">
        {/* Search */}
        <div className="relative">
          <Search size={16} className="absolute left-3 top-2.5 text-gray-400" />
          <input
            type="text"
            placeholder="Search"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            className="pl-9 pr-3 py-2 border rounded-lg text-sm focus:outline-none focus:ring-1 focus:ring-blue-400"
          />
        </div>

        {/* Filter */}
        {/* <button className="flex items-center gap-2 border border-gray-300 text-gray-700 px-3 py-2 rounded-lg hover:bg-gray-50">
          <Filter size={16} /> Filter
        </button>*/}

        {/* Dropdown */}
        {/*<select className="border border-gray-300 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-1 focus:ring-blue-400">
          <option>Created Operating Instruction</option>
          <option>Last Updated</option>
          <option>Status</option>
        </select>*/}

        {/* View Toggle */}
        <div className="flex border border-gray-300 rounded-lg overflow-hidden">
          {/*<button className="px-3 py-2 text-red-500 bg-red-50">
            <List size={16} />
          </button>*/}
          {/*<button className="px-3 py-2 hover:bg-gray-50 text-gray-600">
            <Grid size={16} />
          </button>*/}
        </div>
      </div>
    </div>
  );
};

export default OperatingInstructionHeader;
